// Analytics tracking utility for Google Analytics and Meta Pixel
// Provides centralized event tracking for funnel analysis

/**
 * Track an event in both Google Analytics and Meta Pixel
 * @param {string} eventName - Name of the event
 * @param {object} params - Additional parameters for the event
 */
export const trackEvent = (eventName, params = {}) => {
  // Track in Google Analytics
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
  
  // Track in Meta Pixel
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, params);
  }
  
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics]', eventName, params);
  }
};

/**
 * Track standard Meta Pixel events
 * @param {string} eventName - Standard event name (Lead, CompleteRegistration, etc.)
 * @param {object} params - Additional parameters
 */
export const trackStandardEvent = (eventName, params = {}) => {
  // Track in Meta Pixel (standard event)
  if (typeof window.fbq === 'function') {
    window.fbq('track', eventName, params);
  }
  
  // Track in Google Analytics with equivalent event
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

// Pre-defined funnel events
export const FunnelEvents = {
  // Landing page
  LANDING_PAGE_VIEW: 'landing_page_view',
  LEAD_FORM_START: 'lead_form_start',
  LEAD_FORM_SUBMIT: 'lead_form_submit',
  
  // Quiz
  QUIZ_START: 'quiz_start',
  QUIZ_STEP_COMPLETE: 'quiz_step_complete',
  QUIZ_COMPLETE: 'quiz_complete',
  QUIZ_BACK_CLICK: 'quiz_back_click',
  
  // Results
  RESULTS_VIEW: 'results_view',
  RESULTS_CTA_CLICK: 'results_cta_click',
  
  // Bridge page
  BRIDGE_PAGE_VIEW: 'bridge_page_view',
  BRIDGE_VIDEO_VIEW: 'bridge_video_view',
  BRIDGE_OPTIONS_SCROLL: 'bridge_options_scroll',
  START_BUSINESS_CTA_CLICK: 'start_business_cta_click',
  TRY_PRODUCTS_CTA_CLICK: 'try_products_cta_click',
  
  // Start Business page
  START_BUSINESS_PAGE_VIEW: 'start_business_page_view',
  START_BUSINESS_FORM_START: 'start_business_form_start',
  START_BUSINESS_FORM_SUBMIT: 'start_business_form_submit',
  START_BUSINESS_THANK_YOU: 'start_business_thank_you',
  
  // Try Products page
  TRY_PRODUCTS_PAGE_VIEW: 'try_products_page_view',
  TRY_PRODUCTS_STEP_1: 'try_products_step_1',
  TRY_PRODUCTS_STEP_2: 'try_products_step_2',
  TRY_PRODUCTS_STEP_3: 'try_products_step_3',
  TRY_PRODUCTS_FORM_SUBMIT: 'try_products_form_submit',
  TRY_PRODUCTS_THANK_YOU: 'try_products_thank_you',
  
  // Instagram CTA
  INSTAGRAM_CTA_CLICK: 'instagram_cta_click',
};
